import { useEffect } from 'react';

interface ThankYouProps {
  message?: string;
  redirectUrl?: string;
}

export const ThankYou = ({ message, redirectUrl }: ThankYouProps) => {
  useEffect(() => {
    if (redirectUrl) {
      // Redirect after 2 seconds
      const timeout = setTimeout(() => {
        window.location.href = redirectUrl;
      }, 2000);

      return () => clearTimeout(timeout);
    }
  }, [redirectUrl]);

  return (
    <div className="w-full max-w-2xl mx-auto p-6">
      <div className="bg-primary/10 border border-primary/20 rounded-lg p-8 text-center">
        <svg className="w-16 h-16 text-primary mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
        </svg>
        <h2 className="text-2xl font-bold text-foreground mb-2">Thank You!</h2>
        <p className="text-muted-foreground">{message || 'Your submission has been received.'}</p>
        {redirectUrl && <p className="text-sm text-muted-foreground mt-4">Redirecting you in a moment...</p>}
      </div>
    </div>
  );
};
